/**
 * GoalSuggestion — the "מומלץ: ~1,850 קק״ל" helper line under a daily-goal
 * input (Round 3 / Phase 20). Text only: nothing is auto-filled and nothing
 * is persisted; the coach reads the number and the arithmetic and types the
 * value they want. Shared by the create wizard, the goals modal and the
 * profile settings section so the three stay identical.
 *
 * `suggestion` comes from suggestDailyGoals(): either
 *   { value, unit, explain } or { missing: <hebrew reason> }.
 */

import "./GoalSuggestion.css";

function GoalSuggestion({ suggestion }) {
  if (!suggestion) return null;
  if (suggestion.missing) {
    return <span className="ngs-line ngs-missing">{suggestion.missing}</span>;
  }
  return (
    <span className="ngs-line">
      <strong className="ngs-value">
        מומלץ: ~{Number(suggestion.value).toLocaleString("en-US")} {suggestion.unit}
      </strong>
      <span className="ngs-explain">{suggestion.explain}</span>
    </span>
  );
}

export default GoalSuggestion;
